import { render, staticRenderFns } from "./ConfirmStep.vue?vue&type=template&id=2da5b610&scoped=true&"
import script from "./ConfirmStep.vue?vue&type=script&lang=ts&"
export * from "./ConfirmStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da5b610",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-cfm/mfe-cfm/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2da5b610')) {
      api.createRecord('2da5b610', component.options)
    } else {
      api.reload('2da5b610', component.options)
    }
    module.hot.accept("./ConfirmStep.vue?vue&type=template&id=2da5b610&scoped=true&", function () {
      api.rerender('2da5b610', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wizard/ConfirmStep.vue"
export default component.exports